import { get, post } from './client';
import type {
  TeamNotification,
  TeamNotificationsResponse,
  TeamNotificationsSeenResponse,
} from '@/types/api';

export interface CreateNotificationPayload {
  post: string;
  video_url?: string | null;
}

export async function listTeamNotifications(
  teamId: string
): Promise<TeamNotificationsResponse> {
  return get<TeamNotificationsResponse>(`/api/teams/${teamId}/notifications`);
}

export async function createTeamNotification(
  teamId: string,
  payload: CreateNotificationPayload
): Promise<TeamNotification> {
  return post<TeamNotification>(`/api/teams/${teamId}/notifications`, payload);
}

export async function markTeamNotificationsSeen(
  teamId: string
): Promise<TeamNotificationsSeenResponse> {
  return post<TeamNotificationsSeenResponse>(`/api/teams/${teamId}/notifications/seen`);
}
